import React from 'react';
import './introduction.css';

// Introduction.jsx
function Introduction() {
  return (
    <section className="introduction">
      <h1 className="tagline">
        Revolutionizing Unmanned Aviation <br />
        <span className="highlight">One Take-Off at a Time</span>
      </h1>
      <p className="intro-text">
        KON Aerosystems develops electromagnetic launch systems (eTOLS) that enable the rapid, runway independent deployment of UAVs. Engineered for austere and contested environments, our technology shortens launch & deployment time, extends mission range, and helps operators respond faster to evolving demands.
      </p>
    </section>
  );
}

export default Introduction;
